"use strict";
/*
 * IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: IBM Cognos Analytics
 *
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastNotification = exports.InlineNotification = void 0;
const tslib_1 = require("tslib");
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const react_1 = tslib_1.__importDefault(require("react"));
const carbon_components_react_1 = require("carbon-components-react");
const utils_1 = require("../utils");
const INLINENOTIFICATION_COMPONENT_NAME = 'InlineNotification';
const INLINENOTIFICATION_DISPLAY_NAME = (0, utils_1.getDisplayName)(INLINENOTIFICATION_COMPONENT_NAME);
const INLINENOTIFICATION_DEFAULT_TID = (0, utils_1.getDefaultTid)(INLINENOTIFICATION_COMPONENT_NAME);
exports.InlineNotification = react_1.default.forwardRef((props, ref) => {
    const { 
    // remove - remapped and local props
    'data-tid': dataTid } = props, 
    // pass all other props to Carbon
    otherCarbonProps = tslib_1.__rest(props, ['data-tid']);
    const mappedProps = {
        'data-tid': dataTid !== null && dataTid !== void 0 ? dataTid : INLINENOTIFICATION_DEFAULT_TID,
    };
    if (ref) {
        mappedProps.ref = ref;
    }
    return react_1.default.createElement(carbon_components_react_1.InlineNotification, Object.assign({}, otherCarbonProps, mappedProps));
});
exports.InlineNotification.propTypes = {
    'data-tid': prop_types_1.default.string,
};
exports.InlineNotification.displayName = INLINENOTIFICATION_DISPLAY_NAME;
const TOASTNOTIFICATION_COMPONENT_NAME = 'ToastNotification';
const TOASTNOTIFICATION_DISPLAY_NAME = (0, utils_1.getDisplayName)(TOASTNOTIFICATION_COMPONENT_NAME);
const TOASTNOTIFICATION_DEFAULT_TID = (0, utils_1.getDefaultTid)(TOASTNOTIFICATION_COMPONENT_NAME);
exports.ToastNotification = react_1.default.forwardRef((props, ref) => {
    const { 
    // remove - remapped and local props
    'data-tid': dataTid } = props, 
    // pass all other props to Carbon
    otherCarbonProps = tslib_1.__rest(props, ['data-tid']);
    const mappedProps = {
        'data-tid': dataTid !== null && dataTid !== void 0 ? dataTid : TOASTNOTIFICATION_DEFAULT_TID,
    };
    if (ref) {
        mappedProps.ref = ref;
    }
    return react_1.default.createElement(carbon_components_react_1.ToastNotification, Object.assign({}, otherCarbonProps, mappedProps));
});
exports.ToastNotification.propTypes = {
    'data-tid': prop_types_1.default.string,
};
exports.ToastNotification.displayName = TOASTNOTIFICATION_DISPLAY_NAME;
